<template>
  <div class="mypage_common">
    <div class="common_head">
      <h5>나의상품평</h5>
      <p>고객님께서 등록하신 상품평을 조회하실 수 있습니다.</p>
    </div>
    <div class="common_body">
      <ul class="txtList">
        <li>· 로그인 상태에서 문의하신 내역만 제공됩니다.</li>
        <li>
          · 전화상담이 필요하신 경우 <span>고객센터 02-000-0000</span>를
          이용하시기 바랍니다.
        </li>
      </ul>
      <div class="check_area">
        <ul class="date_filter">
          <li v-for="(day, index) in dayOptions" :key="index">
            <a @click="selectDate(day.value, index)" :class="day.class">
              {{ day.text }}</a
            >
          </li>
        </ul>
        <div class="date_input">
          <input type="date" v-model="startDate" />
          <span>~</span>
          <input type="date" v-model="endDate" />
          <button type="button" @click="requestReview">조회</button>
        </div>
      </div>

      <div v-if="reviews.length > 0">
        <div class="tbl_wrap">
          <table class="list review">
            <colgroup>
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>주문일자</th>
                <th>상품명</th>
                <th>만족도</th>
                <th>답변일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="review in reviews" :key="review.reviewSeq">
                <td>{{ review.invitationCreateDate }}</td>
                <td>
                  <span class="type">[{{ review.categoryName }}]</span>
                  {{ review.campaignName }}
                </td>
                <td>
                  <div class="review_score_wrap">
                    <div
                      class="review_score"
                      :data-score="review.reviewRating"
                    ></div>
                  </div>
                </td>
                <td>
                  <!-- <button type="button" class="btn_revise">상품평 수정</button> -->
                  {{ review.createDate }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="none_cont" v-else>
        <p>고객님께서 등록하신 상품평 내역이 없습니다.</p>
      </div>

      <CustomerServicePagination
        :totalPages="totalPages()"
        :currentPage="currentPage"
        @changePage="changePage"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CustomerServicePagination from "../../common/CustomerServicePagination.vue";

const reviewModule = "reviewModule";

export default {
  components: {
    CustomerServicePagination,
  },

  data() {
    return {
      dayOptions: [
        { text: "오늘", value: 0, class: "active" },
        { text: "10일", value: 10 },
        { text: "30일", value: 30 },
        { text: "60일", value: 60 },
        { text: "90일", value: 90 },
      ],

      currentPage: 1,
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
  },
  methods: {
    ...mapActions(reviewModule, ["requestReviewListByBetween"]),

    selectDate(val, idx) {
      this.dayOptions.forEach((option) => {
        option.class = "";
      });
      this.dayOptions[idx].class = "active";

      this.startDate = new Date().toISOString().split("T")[0];
      this.endDate = new Date().toISOString().split("T")[0];

      this.startDate = new Date(Date.now() - val * 86400000)
        .toISOString()
        .split("T")[0];

      this.requestReview();
    },

    async requestReview() {
      const { currentPage, startDate, endDate } = this;
      await this.requestReviewListByBetween({
        currentPage,
        startDate,
        endDate,
      });
    },

    changePage(page) {
      this.currentPage = page;
      this.requestReview();
    },

    totalPages() {
      return Math.ceil(this.reviewCount / 10);
    },
  },

  computed: {
    ...mapState(reviewModule, ["reviews", "reviewCount"]),
  },

  async mounted() {
    const { currentPage, startDate, endDate } = this;
    await this.requestReviewListByBetween({ currentPage, startDate, endDate });
  },
};
</script>
